import { API_BASE_URL } from "utils/constants";

const PrivateChatPaths = {
  get_message_welcome: `${API_BASE_URL}/chat/welcome?:query`,

  get_private_chat: `${API_BASE_URL}/chat/answer`,

  get_webos_chat: `${API_BASE_URL}/chat/answer_webos`,

  llm_model: `${API_BASE_URL}/chat/llm-model`,

  update_llm_model: `${API_BASE_URL}/chat/update-llm-model`,

  add_llm_model: `${API_BASE_URL}/chat/add-llm-model`,

  get_permission_tree: `${API_BASE_URL}/chat/get_permission_tree?:query`,

  get_api_tree: `${API_BASE_URL}/chat/get_component_list`,

};

export default PrivateChatPaths;
